import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function RoleGuard({ allowed }) {
  const { role, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-center" style={{ height: '100vh' }}>
        <div className="spinner" />
      </div>
    );
  }

  if (!role || !allowed.includes(role)) {
    return <Navigate to="/geen-toegang" replace />;
  }

  return <Outlet />;
}
